import { render, staticRenderFns } from "./GreyTabs.vue?vue&type=template&id=bcf8d46c&scoped=true&"
import script from "./GreyTabs.vue?vue&type=script&lang=js&"
export * from "./GreyTabs.vue?vue&type=script&lang=js&"
import style0 from "./GreyTabs.vue?vue&type=style&index=0&id=bcf8d46c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8d46c",
  null
  
)

export default component.exports